import React from "react"
import { Button } from "reactstrap"

import { SiMicrosoftexcel } from "react-icons/si"

const Export = ({ onExport }) => {
  return (
    <Button
      title="Exportar"
      color="light"
      className="shadow-none"
      onClick={e => onExport(e.target.value)}
    >
      <SiMicrosoftexcel size={16} />
    </Button>
  )
}

export default Export
